import React from "react";
import { TextField } from "@mui/material";
import { DateTime } from "luxon";

const CustomInputField = ({
  placeholder,
  width,
  height,
  backgroundColor,
  InputProps,
  value,
  onChange,
  fontSize,
  maxLength,
  type,
  InputFrontProps,
  border,
  boxShadow,
  marginTop,
  isFront,
  padding,
  fontFamily,
  disabled,
  placeholderColor,
  textCapital,
  maxDate,
  disableFutureDates,
  selectedDate
}) => {
  const enforceMaxLength = (event) => {
    const input = event.target;
    const inputValue = input.value;
    if (maxLength && inputValue.length > maxLength) {
      input.value = inputValue.slice(0, maxLength);
    }
  };
  const todayWithTime = DateTime.now().toFormat("yyyy-MM-dd'T'HH:mm");
  const today = DateTime.now().toISODate();

  const maxDates = disableFutureDates ? (selectedDate ? selectedDate : type == "date" ? today : todayWithTime) : undefined;
  const handleKeyDown = (event) => {
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault();
    }
  };
  const handleKeyUp = (event) => {
    if (event.key === "ArrowUp") {
      event.preventDefault();
    }
  };
  return (
    <TextField
      autoComplete="off"
      placeholder={placeholder}
      value={value}
      disabled={disabled ? disabled : false}
      type={type ? type : "text"}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      onkeyup= {handleKeyUp}
      onInput={enforceMaxLength}
      inputProps={{ 
        maxLength: maxLength ? maxLength : 50, 
        max:disableFutureDates? maxDates :maxDate,
      }}
      sx={{
        width: "100%",
        backgroundColor: backgroundColor,
        // borderRadius: 0,
        borderRadius: "8px",
        border: 0,
        marginTop: marginTop,
        "& .MuiOutlinedInput-root": {
          width: width,
          height: height ? height : "40px",
          fontFamily: fontFamily ? fontFamily : "PoppinsRegular",
          fontSize: fontSize ? fontSize : "clamp(10px, 4vw, 13px)",
          color: "#2E3B47",
          backgroundColor: backgroundColor,
          borderRadius: "8px",
          border: border ? border : "1px solid #DFDFDF",
          boxShadow: boxShadow,
          padding: padding ? padding : "4%",
        },
        "& .MuiOutlinedInput-input": {
          color: "#000",
          textTransform: textCapital ? "capitalize" : "unset",
        },
        "& .MuiInputBase-input::placeholder": {
          color: placeholderColor ? placeholderColor : "#666666",
          opacity: 1,
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "transparent !important ",
          backgroundColor: "transparent",
          color: "#fff !important",
        },
        "&.Mui-disabled": {
          color: "#000000 !important",
          WebkitTextFillColor: "#000000 !important"
        }
      }}
      onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
      InputProps={
        isFront   ? "": { startAdornment: InputFrontProps, endAdornment: InputProps }
      }
    />
  );
};

export default CustomInputField;